import * as constants from "./constants";
import { sortSuppliers } from "../../ActivityTypes/utils";

const initialState = {
  allSuppliers: [],
  fetchingLoading: true,
  updateLoading: false,
  totalRecords: 0,
  isAdding: false,
};

const supplierReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.CREATE_SUPPLIERS:
      return {
        ...state,
        updateLoading: true,
      };
    case constants.CREATE_SUPPLIERS_SUCCESS:
      return {
        ...state,
        updateLoading: false,
        allSuppliers: [action.data, ...state.allSuppliers],
        isAdding: false,
      };
    case constants.CREATE_SUPPLIERS_ERROR:
      return {
        ...state,
        updateLoading: false,
        isAdding: false,
      };

    case constants.FETCH_SUPPLIERS:
      return {
        ...state,
        fetchingLoading: true,
      };
    case constants.FETCH_SUPPLIERS_SUCCESS:

      return {
        ...state,
        fetchingLoading: false,
        allSuppliers: sortSuppliers(action.data),
        isAdding: false,
      };
    case constants.FETCH_SUPPLIERS_ERROR:
      return {
        ...state,
        fetchingLoading: false,
        isAdding: false,
      };
    case constants.UPDATE_SUPPLIERS:
      return {
        ...state,
        updateLoading: true,
      };
    case constants.UPDATE_SUPPLIERS_SUCCESS:
      const updated = state.allSuppliers.map((el) =>
        el.id === action.data.id ? { ...el, ...action.data } : el
      );
      return {
        ...state,
      allSuppliers: updated,
        updateLoading: false,
        isAdding: false,
      };
    case constants.UPDATE_SUPPLIERS_ERROR:
      return {
        ...state,
        updateLoading: false,
        isAdding: false,
      };
    case constants.DELETE_SUPPLIERS:
      return {
        ...state,
        updateLoading: true,
        isAdding: false,
      };
    case constants.DELETE_SUPPLIERS_SUCCESS:
      const updatedData = state.allSuppliers.filter(
        (el) => el.id !== action.data
      );
      return {
        ...state,
        allSuppliers: updatedData,
        updateLoading: false,
        isAdding: false,
      };
    case constants.DELETE_SUPPLIERS_ERROR:
      return {
        ...state,
        updateLoading: false,
        isAdding: false,
      };
    case constants.IS_ADDING_UPDATE:
      return {
        ...state,
        isAdding: action.data,
      };

    default:
      return state;
  }
};

export default supplierReducer;
